// extracted by mini-css-extract-plugin
export default {"container":"VyiFhTinZ7TRYUkxlMO7"};